import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'accountSignin.title',
    defaultMessage: 'Account sign in',
    description: 'Page title for sign in',
  },
  errorHeading: {
    id: 'accountSignin.errorHeadingUnsuccessful',
    defaultMessage: 'Sign in unsuccessful.',
    description: 'Error heading for sign in after unsuccessful log in attempt',
  },
  errorMessage: {
    id: 'accountSignin.errorMessageUnsuccessful',
    defaultMessage: 'Sorry, we were unable to log you in. Please try again.',
    description: 'Message displayed after unsuccessful sign in attempt',
  },
  invalidCredentialsError: {
    id: 'accountSignin.errorMessageInvalid',
    defaultMessage:
      'The email or password you entered is not valid. Please try again.',
    description: 'Message displayed after invalid sign in attempt',
  },
  invalidMfaChallengeCodeError: {
    id: 'accountSignin.errorMessageMfaChallengeInvalid',
    defaultMessage: 'The code you entered is not valid. Please try again.',
    description: 'Message displayed after invalid MFA code entry attempt',
  },
});
